import { useSensorTransport } from '../transports/SensorTransportProvider';

export function useBoxStatus(box_id: number | null) {
  return useSensorTransport().useBoxStatus(box_id);
}
